/**
 * Customer ROUTES
 */
const routes = [
  //Customer
  {
    path: '/Customer/Filter',
    name: 'CustomerFilterViewComponent',
    component: 'Customer/CustomerFilterViewComponent'
  },
  {
    path: '/Customer/Editor/:Id?',
    name: 'CustomerEditorViewComponent',
    component: 'Customer/CustomerEditorViewComponent',
    props: true
  }
];

export default routes;
